// src/pages/ViewBatches.js
import React, { useState, useEffect } from "react";
import axios from "axios";
import Pagination from "../components/Pagination";
import BatchCard from "../components/BatchCard";
import SearchBar from "../components/SearchBar";

const API_BASE_URL = "https://nzpdp-traceability-system-production-c63a.up.railway.app";

const ViewBatches = () => {
  const [batches, setBatches] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const batchesPerPage = 3; 

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/api/admin/batches`)
      .then((response) => {
        setBatches(response.data);
      })
      .catch((error) => {
        console.error(
          "API Error:",
          error.response?.status,
          error.response?.data || error.message
        );
      });
  }, []);

 
  const filteredBatches = batches.filter((batch) =>
    batch.batch_no.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const totalPages = Math.ceil(filteredBatches.length / batchesPerPage);
  const startIndex = (currentPage - 1) * batchesPerPage;
  const currentBatches = filteredBatches.slice(startIndex, startIndex + batchesPerPage);

  const handleDelete = (deletedBatchNo) => {
    setBatches((prevBatches) => prevBatches.filter(batch => batch.batch_no !== deletedBatchNo));
  };
  
 
  return (
    <div>
      <h3>Existing Batches</h3>
      <div className="admin-form"> 
        <SearchBar searchTerm={searchTerm} setSearchTerm={setSearchTerm} placeholder="Search by Batch Number"/>
        <div className="batch-list">
          {currentBatches.length > 0 ? (
            currentBatches.map((batch, index) => (
              <BatchCard key={index} batch={batch} onDelete={handleDelete} />
            ))
          ) : (
            <p className="no-batches">No matching batches found.</p>
          )}
        </div>
        <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={setCurrentPage} />
      </div>
    </div>
  );
  
};

export default ViewBatches;
